import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export default function LiveScherm() {
  const [afdelingen, setAfdelingen] = useState([]);
  const [gekozen, setGekozen] = useState([]);
  const [wisseltijd, setWisseltijd] = useState(20);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [opgeslagen, setOpgeslagen] = useState(false);
  const [gekopieerd, setGekopieerd] = useState(false);
  const [toegestaanIp, setToegestaanIp] = useState('');
  const [ipOpgeslagen, setIpOpgeslagen] = useState(false);
  const [mijnIp, setMijnIp] = useState('');

  const laden = useCallback(async () => {
    try {
      const r = await api.get('/live-dashboard/beheer/config');
      setAfdelingen(r.data.afdelingen || []);
      setGekozen(r.data.afdeling_ids && r.data.afdeling_ids.length ? r.data.afdeling_ids : (r.data.afdelingen || []).map(a => a.id));
      setWisseltijd(r.data.wisseltijd_sec || 20);
      setToken(r.data.token);
      setToegestaanIp(r.data.toegestaan_ip || '');
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { laden(); }, [laden]);

  const toggle = (id) => {
    setGekozen(g => g.includes(id) ? g.filter(x => x !== id) : [...g, id]);
    setOpgeslagen(false);
  };

  const opslaan = async () => {
    try {
      await api.post('/live-dashboard/beheer/config', { afdeling_ids: gekozen, wisseltijd_sec: wisseltijd });
      setOpgeslagen(true);
      setTimeout(() => setOpgeslagen(false), 2500);
    } catch (e) {
      alert('Opslaan mislukt: ' + (e.response?.data?.message || e.message));
    }
  };

  const haalMijnIp = async () => {
    try {
      const r = await api.get('/live-dashboard/beheer/mijn-ip');
      setMijnIp(r.data.ip || '');
      if (r.data.ip) setToegestaanIp(r.data.ip);
      setIpOpgeslagen(false);
    } catch (e) { alert('IP ophalen mislukt: ' + (e.response?.data?.message || e.message)); }
  };

  const ipOpslaan = async () => {
    try {
      await api.post('/live-dashboard/beheer/ip', { toegestaan_ip: toegestaanIp });
      setIpOpgeslagen(true);
      setTimeout(() => setIpOpgeslagen(false), 2500);
    } catch (e) { alert('IP opslaan mislukt: ' + (e.response?.data?.message || e.message)); }
  };

  const kioskLink = token ? `https://live.womsys.nl/?t=${token}` : null;
  const kopieer = () => {
    if (!kioskLink) return;
    navigator.clipboard.writeText(kioskLink);
    setGekopieerd(true);
    setTimeout(() => setGekopieerd(false), 2000);
  };

  const wisselOpties = [10, 20, 30, 60];

  if (loading) return <div style={{ padding: 32, color: '#94a3b8' }}>Laden…</div>;

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: 24 }}>
      <h1 style={{ fontSize: 22, fontWeight: 600, marginBottom: 4 }}>📺 Live scherm</h1>
      <p style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>
        Kies welke afdelingen op het TV-scherm (live.womsys.nl) verschijnen en hoe snel het scherm verspringt.
      </p>

      <div style={{ fontSize: 13, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
        Afdelingen in rotatie
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
        {afdelingen.map(a => {
          const aan = gekozen.includes(a.id);
          return (
            <label key={a.id} onClick={() => toggle(a.id)} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
              background: '#111827', border: `1px solid ${aan ? '#00D4AA' : '#1f2937'}`,
              borderRadius: 10, cursor: 'pointer'
            }}>
              <span style={{
                width: 20, height: 20, borderRadius: 6,
                background: aan ? '#00D4AA' : '#1f2937',
                border: aan ? 'none' : '1px solid #374151',
                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a0e1a', fontSize: 14
              }}>{aan ? '✓' : ''}</span>
              <span style={{ flex: 1, color: aan ? '#fff' : '#94a3b8', fontWeight: 500 }}>{a.naam}</span>
            </label>
          );
        })}
      </div>

      <div style={{ fontSize: 13, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
        Wisseltijd per afdeling
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {wisselOpties.map(w => (
          <button key={w} onClick={() => { setWisseltijd(w); setOpgeslagen(false); }} style={{
            padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14,
            background: wisseltijd === w ? '#00D4AA' : '#1f2937',
            color: wisseltijd === w ? '#0a0e1a' : '#94a3b8',
            fontWeight: wisseltijd === w ? 600 : 400
          }}>{w < 60 ? w + 's' : '1m'}</button>
        ))}
      </div>

      <button onClick={opslaan} style={{
        width: '100%', padding: 12, borderRadius: 10, background: '#00D4AA', color: '#0a0e1a',
        border: 'none', fontWeight: 600, fontSize: 15, cursor: 'pointer', marginBottom: 24
      }}>{opgeslagen ? '✓ Opgeslagen' : 'Opslaan'}</button>

      <div style={{ borderTop: '1px solid #1f2937', paddingTop: 20 }}>
        <div style={{ fontSize: 13, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
          Kiosk-link (voor de TV / mini-PC)
        </div>
        {kioskLink ? (
          <>
            <div style={{
              background: '#111827', border: '1px solid #1f2937', borderRadius: 8, padding: '10px 12px',
              fontSize: 13, color: '#e2e8f0', fontFamily: 'monospace', wordBreak: 'break-all', marginBottom: 10
            }}>{kioskLink}</div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={kopieer} style={{
                padding: '10px 18px', borderRadius: 8, background: '#1f2937', color: '#e2e8f0',
                border: 'none', cursor: 'pointer', fontSize: 14
              }}>{gekopieerd ? '✓ Gekopieerd' : '📋 Kopieer link'}</button>
              <a href={kioskLink} target="_blank" rel="noreferrer" style={{
                padding: '10px 18px', borderRadius: 8, background: '#1f2937', color: '#e2e8f0',
                textDecoration: 'none', fontSize: 14
              }}>↗ Open scherm</a>
            </div>
          </>
        ) : (
          <p style={{ color: '#f0997b', fontSize: 14 }}>Nog geen kiosk-token aangemaakt voor dit bedrijf.</p>
        )}
      </div>

      <div style={{ borderTop: '1px solid #1f2937', paddingTop: 20, marginTop: 24 }}>
        <div style={{ fontSize: 13, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
          Beveiliging — toegestaan IP
        </div>
        <p style={{ color: '#94a3b8', fontSize: 13, marginBottom: 12 }}>
          Laat leeg om het scherm overal te laten werken. Vul het vaste uitgaande IP van het netwerk in (bijv. op locatie bij de klant) om het dashboard alleen daar toegankelijk te maken.
        </p>
        <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
          <input
            value={toegestaanIp}
            onChange={e => { setToegestaanIp(e.target.value); setIpOpgeslagen(false); }}
            placeholder="Leeg = overal toegankelijk"
            style={{
              flex: 1, padding: '10px 12px', borderRadius: 8, border: '1px solid #1f2937',
              background: '#111827', color: '#e2e8f0', fontSize: 14, fontFamily: 'monospace'
            }}
          />
          <button onClick={haalMijnIp} style={{
            padding: '10px 16px', borderRadius: 8, background: '#1f2937', color: '#e2e8f0',
            border: 'none', cursor: 'pointer', fontSize: 14, whiteSpace: 'nowrap'
          }}>📍 Gebruik dit IP</button>
        </div>
        {mijnIp && (
          <p style={{ color: '#00D4AA', fontSize: 12, marginBottom: 10 }}>
            Dit apparaat komt binnen vanaf: {mijnIp}
          </p>
        )}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button onClick={ipOpslaan} style={{
            padding: '10px 18px', borderRadius: 8, background: '#00D4AA', color: '#0a0e1a',
            border: 'none', fontWeight: 600, cursor: 'pointer', fontSize: 14
          }}>{ipOpgeslagen ? '✓ IP opgeslagen' : 'IP opslaan'}</button>
          {toegestaanIp && (
            <button onClick={() => { setToegestaanIp(''); setIpOpgeslagen(false); }} style={{
              padding: '10px 14px', borderRadius: 8, background: 'transparent', color: '#94a3b8',
              border: '1px solid #1f2937', cursor: 'pointer', fontSize: 14
            }}>Leegmaken</button>
          )}
        </div>
        <p style={{ color: '#f0997b', fontSize: 12, marginTop: 10 }}>
          Let op: zet dit alleen vast op een netwerk met een vast IP (bijv. bedrijfsnetwerk). Op een thuisnetwerk verandert het IP en sluit je jezelf mogelijk buiten.
        </p>
      </div>
    </div>
  );
}
